import { Components, Theme } from '@mui/material/styles';
import { fontFamily } from 'theme/typography';

export const MuiDialogActions: Components<Theme>['MuiDialogActions'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontFamily,
      padding: theme.spacing(8, 16, 16, 16),
    }),
  },
};
